import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

// A persistent shortcut back to the exact notification card the user just
// came from, rendered on top of ANY page reached by clicking a notification
// (so there's no need to hunt back via the bell icon in the sidebar).
export function BackToNotifications() {
  const location = useLocation();
  const navigate = useNavigate();
  const notifId = location.state?.fromNotification;
  if (!notifId || location.pathname === "/app/notifications") return null;
  return (
    <button data-testid="back-to-notifications"
      onClick={() => navigate("/app/notifications", { state: { scrollToId: notifId } })}
      className="fixed bottom-24 left-4 z-40 flex items-center gap-2 rounded-full border border-gold/40 bg-[#0D1117]/95 px-4 py-2.5 text-[13px] font-bold text-gold shadow-[0_10px_30px_-10px_rgba(0,0,0,0.65)] backdrop-blur-md transition-colors hover:bg-gold hover:text-gold-ink lg:bottom-6 lg:left-[268px]">
      <ArrowLeft size={15} weight="bold" />
      Back to Notifications
    </button>
  );
}
